(function () {
  'use strict';

  var REVIEWS_OFFSET = 80;

  function findReviewsTarget() {
    return (
      document.getElementById('pdp-reviews') ||
      document.getElementById('ptabReview') ||
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-review-widget') ||
      document.querySelector('.jdgm-rev-widg')
    );
  }

  function ensureReviewsAnchor() {
    var target = findReviewsTarget();
    if (!target || document.getElementById('pdp-reviews')) return target;

    target.id = 'pdp-reviews';
    return target;
  }

  function scrollToReviews() {
    var target = ensureReviewsAnchor();
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.scrollY - REVIEWS_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function init(scope) {
    var context = scope || document;
    ensureReviewsAnchor();

    context.querySelectorAll('[data-pdp-reviews-scroll]').forEach(function (link) {
      if (link.dataset.pdpReviewsScrollInit === 'true') return;
      link.dataset.pdpReviewsScrollInit = 'true';

      link.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToReviews();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      window.setTimeout(init, 500);
    });
  } else {
    init();
    window.setTimeout(init, 500);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
